import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const NeedHelp = ({
  onLostDevice,
  onChangePrecedence,
  toggleBackupCodesModal
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "body-125",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "twoFactorV4.needHelp.title"
    })
  }), /*#__PURE__*/_jsxs(List, {
    justifyContent: "center",
    use: "inline-divided",
    children: [onChangePrecedence && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "switch-2fa-verification-method-button",
        onClick: onChangePrecedence,
        paddingInline: "0",
        size: "small",
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.needHelp.tryAnother"
        })
      })
    }), toggleBackupCodesModal && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: toggleBackupCodesModal,
        paddingInline: "0",
        size: "small",
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.needHelp.backupCode"
        })
      })
    }), onLostDevice && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onLostDevice,
        paddingInline: "0",
        size: "small",
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.needHelp.resetDevice"
        })
      })
    })]
  })]
});